

















import { defineComponent } from "@vue/composition-api";

export default defineComponent({
    name: "alert",
    props: {
        icon: { type: String, required: false },
        type: { type: String, default: "info" },
    },
    setup() {},
});
